/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { CurrencyValueModel } from './currency-value.model';
import { SubcoServiceProviderVoModel } from './subco-service-provider-vo.model';

export class SegmentSubcoOrderViewSetModel extends JSONable {
  uuid: string | null = null;

  owner: string | null = null;

  orderNumber = '';

  shipmentGroupUuid: string | null = null;

  orderStatus = '';

  price: CurrencyValueModel | null = null;

  serviceProviderVo: SubcoServiceProviderVoModel | null = null;
}
